import { Box, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

/** Figma 639-87557 — inline DBT / Non-DBT pill in mobile input suffix. */
export const DbtRegistrationBadge = ({ label, loading = false }) => {
  if (loading) {
    return (
      <CircularProgress
        size={18}
        thickness={4}
        aria-label="Checking DBT registration"
        sx={{ color: "primary.main", mr: 0.5 }}
      />
    );
  }

  if (!label) return null;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        bgcolor: "#FAEBC7",
        color: "#8B6914",
        borderRadius: "8px",
        px: 1,
        py: 0.25,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: "18px",
        whiteSpace: "nowrap",
        textTransform: "uppercase",
      }}
    >
      {label}
    </Box>
  );
};

DbtRegistrationBadge.propTypes = {
  label: PropTypes.string,
  loading: PropTypes.bool,
};

export default DbtRegistrationBadge;
